var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchAmazonHoneycode32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture/32/Arch_Amazon-Honeycode_32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD0816",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5252",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture/32/Arch_Amazon-Honeycode_32",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon-Service/32/Amazon-Honeycode_32",
    transform: "translate(4.000000, 4.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13,18.811 L15.996,20.548 L23,16.602 L22.993,19.978 L16,24.033 L13,22.294 L13,18.811 Z M12.097,10.058 L15.06,11.822 L12,13.597 L12,21.714 L9,19.975 L9,11.853 L12.097,10.058 Z M13,14.173 L16.043,12.408 L19,14.169 L19,17.708 L16.004,19.397 L13,17.655 L13,14.173 Z M23,15.454 L20,17.145 L20,13.601 L13.087,9.484 L16,7.795 L23,11.853 L23,15.454 Z M27,22.294 L23.993,24.038 L24,11.277 L16,6.639 L8,11.277 L8,20.551 L16,25.189 L22.993,21.135 L22.993,24.617 L16,28.672 L5,22.294 L5,9.534 L16,3.156 L27,9.534 L27,22.294 Z M16,2 L4,8.958 L4,22.87 L16,29.828 L28,22.87 L28,8.958 L16,2 Z",
    id: "Fill-3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchAmazonHoneycode32);
export default __webpack_public_path__ + "static/media/Arch_Amazon-Honeycode_32.dc5ed0fd4742c0747cad18aff344d586.svg";
export { ForwardRef as ReactComponent };